import { Loader } from '@/shared/ui';
import type { FC } from 'react';

export const GlobalPageLoader: FC = () => {
  return (
    <div className="flex min-h-dvh min-w-dvw items-center justify-center">
      <Loader />
    </div>
  );
};
